import { inject, Pipe, PipeTransform } from '@angular/core';
import { NgxTranslatorService } from './ngx-translator.service';

/**
 * Pipe para traducir cadenas de texto utiliza ngx-translate.
 */
@Pipe({
  name: 'translate',
  standalone: true,
  pure: true
})
export class AppTranslationPipe implements PipeTransform {
  /**
   * Servicio de traducción de ngx-translate.
   */
  private readonly translateService = inject(NgxTranslatorService);

  /**
   * Traduce una cadena de texto con base en la configuración de idioma.
   * @param value Cadena de texto a traducir.
   * @returns {string} Cadena de texto traducida.
   */
  transform(value?: string): string {
    if (!value) {
      return '';
    }

    return this.translateService.get(value);
  }
}
